export default __webpack_public_path__ + "static/media/ins.74bc62f5.png";